<img src="assets/img/mobilise-loader.gif" class="loader-img" height="50px" />

